import {AfterViewInit, Component, ViewChild} from '@angular/core';
import {ShopItemsService} from "./shop-items.service";
import {MatPaginator} from "@angular/material/paginator";
import {FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {ShopItemsDataSource} from "./shop-items.data-source";
import {IInventoryItemV2} from "./interfaces/inventory-item.interface";
import {MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-shop-items',
  templateUrl: './shop-items.component.html',
  styleUrls: ['./shop-items.component.scss']
})
export class ShopItemsComponent implements AfterViewInit {
  @ViewChild(MatPaginator, {static: false}) paginator!: MatPaginator;

  public shopItemColumns: string[] = ['id', 'item', 'price', 'steamPrice', 'available', 'actions'];
  public shopItemsSource = new ShopItemsDataSource(this.shopItemsService);

  public shopItemsForm: FormGroup = this.fb.group({
    query: new FormControl(''),
    minPrice: new FormControl(''),
    maxPrice: new FormControl(''),
  })

  constructor(private shopItemsService: ShopItemsService,
              private fb: FormBuilder,
              public dialogRef: MatDialogRef<ShopItemsComponent>) {
    this.loadShopItems();
  }

  ngAfterViewInit() {
    this.paginator.page.subscribe(() => this.loadShopItems(this.shopItemsForm.value));
  }

  loadShopItems(params?: any): void {
    this.shopItemsSource.loadData(
      this.paginator?.pageIndex || 0, // offset
      this.paginator?.pageSize || 10, // limit
      params
    );
  }

  search(): void {
    this.loadShopItems(this.shopItemsForm.value)

    this.paginator.firstPage();
  }

  selectItem(item: IInventoryItemV2): void {
    this.dialogRef.close(item);
  }


}
